import React from "react";
import { NavLink, useNavigate } from "react-router-dom";

const Nav = () => {
  const nav = useNavigate();

  const navStyles = {
    navbar: {
      background: "linear-gradient(90deg, #6a11cb, #2575fc)",
    },
    navLink: {
      color: "white",
      marginRight: "8px",
      transition: "all 0.3s ease",
      textDecoration: "none",
    },
    navLinkHover: {
      color: "#ffdd57",
    },
    activeLink: {
      fontWeight: "bold",
      borderBottom: "2px solid #ffdd57",
    },
    logoutBtn: {
      cursor: "pointer",
      color: "#ffdddd",
    },
    logoutBtnHover: {
      color: "#ff5555",
    },
    togglerIcon: {
      filter: "invert(1)",
    },
  };

  return (
    <nav className="navbar navbar-expand-lg" style={navStyles.navbar}>
      <div className="container-fluid">
        {/* Brand */}
        <NavLink
          className="navbar-brand fw-bold"
          to="/home"
          style={{ color: "white" }}
        >
          Salman
        </NavLink>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          style={{ border: "none" }}
        >
          <span
            className="navbar-toggler-icon"
            style={navStyles.togglerIcon}
          ></span>
        </button>

        {/* Nav Links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {[
              { to: "/home", label: "Customer" },
              { to: "/addcustomer", label: "Add Customer" },
              { to: "/addsales", label: "Add Sales" },
              { to: "/sales", label: "Sales" },
              { to: "/bill", label: "Bill" },
              { to: "/billreport", label: "Bill Report" },
              { to: "/addpurchase", label: "Add Purchase" },
              { to: "/purchasereport", label: "Purchase Report" },
              { to: "/viewsaless", label: "View Sales" },
              { to: "/move", label: "Move" },
            ].map((item, index) => (
              <li className="nav-item" key={index}>
                <NavLink
                  className="nav-link"
                  to={item.to}
                  style={({ isActive }) =>
                    isActive
                      ? { ...navStyles.navLink, ...navStyles.activeLink }
                      : navStyles.navLink
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}

            {/* Logout */}
            <li className="nav-item">
              <span
                className="nav-link"
                style={navStyles.logoutBtn}
                onMouseEnter={(e) =>
                  (e.target.style.color = navStyles.logoutBtnHover.color)
                }
                onMouseLeave={(e) =>
                  (e.target.style.color = navStyles.logoutBtn.color)
                }
                onClick={() => {
                  window.localStorage.removeItem("pro");
                  nav("/");
                }}
              >
                Logout
              </span>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
